import clsx from "clsx";
import styles from "./detections.module.scss";

type Props = {
  className?: string;
  count: number | string;
  match: number | string;
  onClick?: () => void;
};
const MultiScanner = ({ className, count, match, onClick }: Props) => (
  <section
    data-testid="report_summary_multi_scanner_container"
    className={clsx(styles.detections_section, className)}
    onClick={onClick}
  >
    <span className={styles.detections_section_title}>
      Community Threat Detections
    </span>
    <div className="text-center">
      <span
        className={styles.detections_multi_scanner_matches}
        data-testid="report_summary_multi_scanner_matches"
      >
        {match}
      </span>{" "}
      /{" "}
      <span
        className={styles.detections_multi_scanner_count}
        data-testid="report_summary_multi_scanner_count"
      >
        {count}
      </span>
    </div>
  </section>
);

export default MultiScanner;
